import initialState from './initialState'
import router from '../routes'
import ServiceWorker from '../registerServiceWorker'

/** 👇 open modal */
const SET_MAX_QNA_ACTIVE = (state, payload) => {
  state.maxQnaActive = payload
}
const SET_IS_PREMIUM_CONTENT = (state, payload) => {
  state.isPremiumContent = payload
}
const SET_IS_VIP_FEATURES = (state, payload) => {
  state.isVipFeatures = payload
}
const SET_IS_TO_MANY_LOGIN = (state, payload) => {
  state.isToManyLogin = payload
}
const SET_IS_OPEN_MODAL_REWARD_RISK_RATIO_CALCULATION = (state, payload) => {
  state.isOpenModalRewardRiskRatioCalculation = payload
}
const SET_IS_OPEN_MODAL_CONTACT_SUPPORT = (state, payload) => {
  state.isOpenModalContactSupport = payload
}
const SET_IS_OPEN_MODAL_SUCCESS_CHANGE_PASSWORD = (state, payload) => {
  state.isOpenModalSuccessChangePassword = payload
}
const SET_IS_OPEN_MODAL_VIDEO_TUTORIAL = (state, payload) => {
  state.isOpenModalVideoTutorial = payload
}
const SET_IS_OPEN_MODAL_SHARE = (state, payload) => {
  state.isOpenModalShare = payload
}

const SET_PREVIEW_IMAGE = (
  state,
  payload = {
    isOpen: false,
    src: null,
  }
) => {
  state.previewImage = payload
}

const SET_HAS_ONGOING_QNA = (
  state,
  payload = {
    status: false,
    message: '',
  }
) => {
  state.hasOngoingQna = payload
}

const SET_INPUT_RECORD = (state, payload) => {
  state.inputRecord = { ...state.inputRecord, ...payload }
}

const SET_OTP_RECORD = (state, payload = {}) => {
  const otpData = state.inputRecord?.otp || {}
  state.inputRecord = {
    ...state.inputRecord,
    otp: {
      ...otpData,
      ...payload,
    },
  }
}

const RESET_INPUT_RECORD = (state, payload) => {
  state.inputRecord = {}
}

const RESET_ERROR = (state, payload) => {
  state.error = {
    status: '',
    message: '',
  }
}

const SET_VERIFY_USER_ACCOUNT = (state, payload) => {
  state.verifyUserAccount = payload
}

const SET_REGISTER_SUCCESS = (state, payload) => {
  state.isRegisterSuccess = payload
}

const SET_LOADING = (state, payload = false) => {
  state.isLoading = payload
}

const SET_ENABLE_STEPPER_GUIDE = (state, payload = false) => {
  state.isEnableStepperGuide = payload
}

const SET_SPINNER_LOADING = (state, payload = false) => {
  state.isSpinnerLoading = payload
}

const SET_IS_OPEN_TERM_CONDITION = (state, payload) => {
  state.isOpenTermCondition = payload
}

const SET_IS_OPEN_DISCLAIMER = (state, payload) => {
  state.isOpenDisclaimer = payload
}

const SET_PAGINATION = (state, payload) => {
  state.pagination = {
    page_size: payload.page_size,
    current_page: payload.current_page,
    next_page: payload.next_page,
    total_page: payload.total_page,
  }
}

const SET_ERROR = async (state, payload) => {
  const path = location.pathname
  const isLoginPage = path.includes('login')
  const isSignupPage = path.includes('signup')
  const isStatus401 = payload?.response?.status === 401
  const disableError = isStatus401 && !isLoginPage && !isSignupPage

  if (disableError) return

  if (payload?.response?.data) {
    const msg =
      payload.response.data.message === 'maximal deposit is 1000000000000'
        ? 'Maksimum modal hanya sampai Rp 1.000.000.000.000'
        : payload.response.data.message

    if (payload.response?.status > 500) {
      state.error = {
        data: payload.response.data || null,
        message: 'Server Error',
        status: '500',
      }
      return
    }

    if (msg === 'Not Allowed') {
      router.push({
        query: {
          alertLogout: true,
        },
      })
      return
    }

    if (
      msg === 'not membership/membership is expired' ||
      msg === 'no preview for free user'
    ) {
      state.selectedCategory = ''
      const { backLink } = router.history.current.meta
      router.push({ path: '/' + backLink })
      return
    }

    state.error = {
      data: payload.response?.data ?? null,
      message: msg,
      status: payload.response.status,
    }
    return
  }

  state.error = {
    data: null,
    message: typeof payload === 'string' ? payload : 'Server Error',
    status: 500,
  }
}

const SET_GSI_ERROR = async (state, payload) => {
  state.gsiError = {
    status: payload.status,
    message: payload.message,
    gsiToken: payload.gsiToken,
  }
}

const SET_SUCCESS = async (state, payload) => {
  state.success = {
    status: payload.status,
    message: payload.data.message,
  }
}

const SET_NEW_NOTIF = (state, payload) => {
  state.newNotif = state.newNotif + Number(payload)
}

const SET_NOTIF_COUNT = (state, payload) => {
  state.newNotif = Number(payload)
}

const SET_NOTIF_CATEGORY = (state, payload) => {
  state.listNotificationCategory = payload
}

const SET_ENABLE_FEATURE = (state, payload) => {
  state.enableFeature = {
    feature: payload?.feature ?? '',
    status: payload?.status ?? false,
    message: payload?.message ?? '',
    product: payload?.product ?? [],
    type: payload?.type ?? 'none',
    submited: payload?.submited ?? false,
  }
}

const SET_SUBSCRIPTION = (state, payload) => {
  state.subscription = payload
}

const SET_MEMBERSHIP_STATUS = (state, payload) => {
  state.membership = payload
}

const SET_MEMBER_DETAILS = (state, payload) => {
  state.membershipData = payload
}

const SET_PAGE_HISTORY = (state, payload) => {
  const result = payload.length > 0 ? [...state.pageHistory, payload] : []

  state.pageHistory = result
}

const SET_FILTER = (state, payload) => {
  state.filter = payload
}
const CLEAR_FILTER = (state) => {
  state.filter = {
    filter: '',
    endDate: '',
    profitBy: '',
    startDate: '',
    content_format: '',
  }
}

const SET_SEARCH = (state, payload) => {
  state.search = payload
}
const OPEN_SEARCH = (state, payload) => {
  state.openSearch = payload
}
const SET_Y_POS = (state, payload) => {
  state.scrollYPos = payload
}
/* #endregion */

/* #region  auth */
const LOGIN = (state, payload) => {
  const dbParams = {
    ...payload,
    config: {
      apiUrl: process.env.VUE_APP_BASE_SERVICE_URL_REFACTOR,
      baseUrl: process.env.VUE_APP_API_URL,
      academyUrl: process.env.VUE_APP_ACADEMY_URL,
      oldAcademyUrl: process.env.VUE_APP_OLD_ACADEMY_URL,
      landingpageUrl: process.env.VUE_APP_LANDING_PAGE_URL,
    },
  }

  ServiceWorker.register(dbParams)

  localStorage.clear()

  state.user.id = payload.id
  state.user.name = payload.name
  state.user.email = payload.email
  state.user.phone = payload.phone
  state.user.token = payload.token
  state.user.refresh_token = payload?.refresh_token ? payload.refresh_token : ''
  state.isOpenTermCondition = true
  state.isOpenDisclaimer = false
}

const SET_REFRESH_TOKEN = (state, payload) => {
  state.user.token = payload.token
  state.user.refresh_token = payload.refresh_token
}

const LOGOUT = async (state) => {
  /** 👇 [ID] logout perlu reset state satu satu, karna kalo di replace semua suka nyangkut */
  state.user = initialState.user
  state.analysisHome = initialState.analysisHome
  state.educationHome = initialState.educationHome
  state.currentPromotionPopup = initialState.currentPromotionPopup
  state.faqHome = initialState.faqHome
  state.inputRecord = initialState.inputRecord
  state.listEvent = initialState.listEvent
  state.listForYou = initialState.listForYou
  state.listPromotionBanner = initialState.listPromotionBanner
  state.listTicker = initialState.listTicker
  state.membership = initialState.membership
  state.membershipData = initialState.membershipData
  state.promotionPopup = initialState.promotionPopup
  state.appearedPromotions = initialState.appearedPromotions
  state.categories = initialState.categories
  state.error = initialState.error
  state.listChat = initialState.listChat
  state.listAnalysis = initialState.listAnalysis
  state.listQuestion = initialState.listQuestion
  state.listTiket = initialState.listTiket
  state.termCondition = initialState.termCondition
  state.newNotif = initialState.newNotif
  state.firebaseToken = ''
  state.qnaRecord = {}
}
/* #endregion */

/* #region  Live Trading */
const SET_LIVE_TRADE_DATA = (state, payload) => {
  state.liveTrade = [...state.liveTrade, ...payload]
}

const ADD_LIVE_TRADE = (state, payload) => {
  state.liveTrade.unshift(payload)
}

const CLEAR_LIVE_TRADE = (state) => {
  state.liveTrade = []
}

const SET_LIVE_TRADE_DETAIL = (state, payload) => {
  state.liveTradeDetail = payload
}

const SET_CHART_STOCK = (state, payload) => {
  state.chartStock = payload.data
  state.error = {}
}
/* #endregion */

/* #region  Stok */
const SET_MY_STOCK = (state, payload) => {
  state.myStock = payload.data
  state.error = {}
}
const SET_BUY_STOCK = (state, payload) => {
  state.buyStock = payload.data
  state.error = {}
}
const SET_SELL_STOCK = (state, payload) => {
  state.sellStock = payload.data
  state.error = {}
}
const SET_ANALYSIS_STOCK = (state, payload) => {
  state.analysisStock = payload.data
  state.error = {}
}
const SET_LIST_STOCK = (state, payload) => {
  const newStocks = payload.data
  const query = payload?.params?.query
  const isFirstPage = payload?.params?.page === 1

  if (!newStocks?.length) return

  state.error = {}

  /**
   * if the data is obtained from the search results directly show the results
   * to fix the bug cannot render result of search stock
   */
  if (isFirstPage) return (state.listStock = newStocks)

  /** otherwise, merge the data in the state with the data from the api */
  state.listStock = [...state.listStock, ...newStocks].reduce((acc, curr) => {
    const find = acc.find((item) => item.code === curr.code)
    if (find) return [...acc]
    return [...acc, curr]
  }, [])
  // .sort((a, b) => (a.code > b.code ? 1 : -1))
}
const RESET_LIST_STOCK = (state) => {
  state.listStock = []
}

const SET_LAST_PRICE = (state, payload) => {
  state.lastPriceStock = payload
}
/* #endregion */

/* #region Push Notif  */
const SET_PUSH_NOTIF = (state, payload) => {
  state.pushNotif = payload.data
  state.error = {}
}
/* #endregion */

/* #region   Firebase */
const SET_FIREBASE_TOKEN = (state, payload = '') => {
  state.firebaseToken = payload
  state.error = {}
}
const SET_FIREBASE_REMOTE_CONFIG = (state, payload) => {
  state.firebaseRemoteConfig = payload
  state.error = {}
}

/* #endregion */

/* #region  Global Filter */
const SET_CATEGORY = (state, payload) => {
  state.selectedCategory = payload
  state.error = {}
}
/* #endregion */

/* #region  Sahamku */
const SET_STOCK_DETAILS = (state, payload) => {
  state.stockDetails = payload
  state.error = {}
}
/* #endregion */

/* #region notification  */
const SET_LIST_NOTIFICATION = (state, payload) => {
  state.listNotification = payload.data
  state.error = {}
}

const SET_READ_NOTIFICATION = (state, payload) => {
  const modify = state.listNotification.map((res) => {
    if (res.id === payload) {
      return {
        ...res,
        is_read: true,
      }
    }

    return res
  })
  state.listNotification = modify
  state.newNotif = state.newNotif - 1
  state.error = {}
}

const CLEAR_LIST_NOTIFICATION = (state) => {
  state.listNotification = []
  state.error = {}
}

/* #endregion */

/* #region member  */
const SET_LIST_PROGRAM = (state, payload) => {
  state.listProgram = payload.data ?? initialState.listProgram
}

/* #endregion */

/* #region content  */
const SET_LIST_CONTENT = (state, payload) => {
  payload.data.forEach((el) => {
    state.listContent.push(el)
  })
  state.error = {}
}

const SET_LIST_CONTENT_CHILD = (state, payload) => {
  state.listContentChild = payload
  state.error = {}
}

const SET_CONTENT = (state, payload) => {
  state.content = payload
  state.error = {}
}

const CLEAR_LIST_CONTENT = (state) => {
  state.listContent = []
  state.error = {}
}

const SET_LIST_TICKER = (state, payload) => {
  state.listTicker = payload
  state.error = {}
}

const SET_LIST_PROMOTION_BANNER = (state, payload) => {
  state.listPromotionBanner = payload
  state.error = {}
}

const SET_LIST_EVENT = (state, payload) => {
  state.listEvent = payload.data
  state.error = {}
}
const SET_LIST_BANNER_EDUCATION = (state, payload) => {
  state.listBannerEducation = payload.data
  state.error = {}
}
const SET_EDUCATION_HOME = (state, payload) => {
  state.educationHome = payload.data
  state.error = {}
}
const SET_ANALYST_HOME = (state, payload) => {
  state.analysisHome = payload.data
  state.error = {}
}
const SET_FAQ_HOME = (state, payload) => {
  state.faqHome = payload.data
  state.error = {}
}
const SET_PROMOTION_POPUP = (state, payload) => {
  state.promotionPopup = payload.data
  state.error = {}
}

const SET_PROMOTION_DETAIL = (state, payload) => {
  state.promotion = payload.data
  state.error = {}
}

/* #endregion */

/* #region Analysis  */
const SET_LIST_ANALYST = (state, payload) => {
  payload.data.forEach((el) => {
    state.listAnalysis.push(el)
  })
  state.error = {}
}

const SET_ANALYST = (state, payload) => {
  state.analysis = payload
  state.error = {}
}

const CLEAR_LIST_ANALYST = (state) => {
  state.listAnalysis = []
  state.error = {}
}
/* #endregion */

/* #region FAQ  */
const SET_LIST_FAQ = (state, payload) => {
  payload.data.forEach((el) => {
    state.listFaq.push(el)
  })
  state.error = {}
}

const SET_FAQ = (state, payload) => {
  state.faq = payload
  state.error = {}
}

const SET_LIST_FAQ_RELATED = (state, payload) => {
  state.listFaqRelated = payload
  state.error = {}
}

const CLEAR_LIST_FAQ = (state) => {
  state.listFaq = []
  state.error = {}
}

const SET_FAQ_FREQUENT = (state, payload) => {
  payload.data.forEach((el) => {
    state.faqFrequent.push(el)
  })
  state.error = {}
}

const CLEAR_LIST_FAQ_FREQUENT = (state) => {
  state.faqFrequent = []
  state.error = {}
}

const SET_FAQ_LAST = (state, payload) => {
  state.faqLast = payload.data
  state.error = {}
}
/* #endregion */

/* #region Tanya  */
const SET_LIST_CHAT = (state, payload) => {
  state.listChat = [...state.listChat, ...payload.data]
  state.error = {}
}

const ADD_LIST_CHAT = (state, payload) => {
  state.listChat.push(payload.data)
  state.error = {}
}

const CLEAR_LIST_CHAT = (state) => {
  state.listChat = []
  state.error = {}
}

const SET_STATUS_QA = (state, payload) => {
  state.statusQa = payload.data
  state.error = {}
}

const SET_QNA_RECORD = (state, payload = {}) => {
  state.qnaRecord = !!Object.keys(payload)?.length
    ? { ...state.qnaRecord, ...payload }
    : {}
}

const SET_PORTFOLIO_QA = (state, payload = {}) => (state.portfolioQa = payload)

const SET_AUTO_ANSWER = (state, payload) => {
  state.autoAnswer = payload.data
  state.error = {}
}

const SET_LIST_QUESTION = (state, payload) => {
  state.listQuestion = payload.data
  state.error = {}
}

const CLEAR_LIST_QUESTION = (state) => {
  state.listQuestion = []
}

/* #endregion */

/* #region  App Version */
// const SET_APP_VERSION = async (state, payload) => {
//   await Object.assign(state, { ...initialState })
//   state.appVersion = payload
//   state.error = {}
// }

/* #endregion */

/* #region  Belanjaan */
const SET_LIST_BELANJA = (state, payload) => {
  payload.data.forEach((el) => {
    state.listBelanja.push(el)
  })
  state.error = {}
}

const CLEAR_LIST_BELANJA = (state) => {
  state.listBelanja = []
  state.error = {}
}
/* #endregion */

/* #region  Belanjaan */
const SET_LIST_LANGGANAN = (state, payload) => {
  payload.data.forEach((el) => {
    state.listLangganan.push(el)
  })
  state.error = {}
}

const CLEAR_LIST_LANGGANAN = (state) => {
  state.listLangganan = []
  state.error = {}
}
/* #endregion */

/* #region  categories */
const SET_LIST_CATEGORIES = (state, payload) => {
  state.categories = payload.data.map((el) => {
    return { id: el.id, key: el.name, value: el.id, slug: el.slug }
  })
  state.categories.unshift({ id: '', key: 'All', value: '', slug: '' })
  state.error = {}
}

const SET_LIST_CATEGORIES_QNA = (state, payload) => {
  state.categories = payload.data?.map((item) => {
    return {
      ...item,
      route: 'qnafaq',
    }
  })

  state.error = {}
}

/* #endregion */

/* #region  tiket */
const SET_LIST_TIKET = (state, payload) => {
  payload.data.forEach((el) => {
    state.listTiket.push(el)
  })
  state.error = {}
}
const ADD_TIKET = (state, payload) => {
  state.tiket = payload.data

  state.error = {}
}
const REMOVE_LIST_TIKET = (state, payload) => {
  state.listTiket = state.listTiket.filter((el) => el.id !== payload.id)
}

const CLEAR_LIST_TIKET = (state) => {
  state.listTiket = []
  state.error = {}
}

const CLEAR_LIST_TIKET_DETAIL = (state) => {
  state.listTiketDetail = []
  state.error = {}
}
/* #endregion */

const SET_FOR_YOU = (state, payload) => {
  state.listForYou = payload.data
  state.error = {}
}

const SET_LANDINGPAGE = (state, payload) => {
  state.landingpage = payload.data
  state.error = {}
}

const SET_FORGOT_SUCCESS_DIALOG = (state, payload) => {
  state.forgotSuccessDialog = payload
}

const SET_RESEND_OTP_REMAINING = (state, payload) => {
  state.resendOTPRemaining = payload
}

const SET_CHART_CONFIG = (state, payload) => {
  state.chartConfig = payload
}

const SET_IS_CLOSE_POPUP_BANNER = (state, payload) => {
  if (state.promotionPopup.length <= state.currentPromotionPopup) {
    state.isClosePopupBanner = payload
  } else {
    state.currentPromotionPopup += 1
  }
}

const SET_APPEARED_PROMOTIONS = (state, payload) => {
  state.appearedPromotions = payload
}

const SET_DIAL_CODE = (state, payload = []) => {
  state.dialCode = payload
}

const SET_USER_AGENT = (state, payload) => {
  state.userAgent = payload ?? ''
}

const SET_FINGERPRINT = (state, payload) => {
  state.fingerprint = payload ?? ''
}

export default {
  SET_USER_AGENT,
  SET_FINGERPRINT,
  SET_REGISTER_SUCCESS,
  LOGIN,
  SET_REFRESH_TOKEN,
  LOGOUT,
  SET_NEW_NOTIF,
  SET_NOTIF_COUNT,
  SET_NOTIF_CATEGORY,
  SET_LOADING,
  SET_ENABLE_STEPPER_GUIDE,
  SET_LIVE_TRADE_DATA,
  SET_PAGINATION,
  SET_ERROR,
  SET_GSI_ERROR,
  SET_SUCCESS,
  ADD_LIVE_TRADE,
  CLEAR_LIVE_TRADE,
  SET_BUY_STOCK,
  SET_SELL_STOCK,
  SET_MY_STOCK,
  SET_PUSH_NOTIF,
  SET_FIREBASE_TOKEN,
  SET_FIREBASE_REMOTE_CONFIG,
  SET_CATEGORY,
  SET_STOCK_DETAILS,
  SET_LIST_NOTIFICATION,
  SET_READ_NOTIFICATION,
  CLEAR_LIST_NOTIFICATION,
  SET_LIST_PROGRAM,
  SET_LIST_CONTENT,
  CLEAR_LIST_CONTENT,
  SET_CONTENT,
  SET_LIST_FAQ,
  SET_FAQ,
  SET_LIST_FAQ_RELATED,
  CLEAR_LIST_FAQ,
  SET_LIST_CHAT,
  CLEAR_LIST_CHAT,
  ADD_LIST_CHAT,
  // SET_APP_VERSION,
  SET_LIST_BELANJA,
  CLEAR_LIST_BELANJA,
  SET_LIST_CATEGORIES,
  SET_LIST_CATEGORIES_QNA,
  SET_FAQ_FREQUENT,
  SET_FAQ_LAST,
  CLEAR_LIST_FAQ_FREQUENT,
  SET_LIST_CONTENT_CHILD,
  SET_LIST_LANGGANAN,
  CLEAR_LIST_LANGGANAN,
  SET_LIST_TIKET,
  ADD_TIKET,
  CLEAR_LIST_TIKET,
  CLEAR_LIST_TIKET_DETAIL,
  SET_LIST_TICKER,
  SET_LIST_PROMOTION_BANNER,
  SET_LIST_EVENT,
  SET_ANALYSIS_STOCK,
  SET_IS_OPEN_TERM_CONDITION,
  SET_IS_OPEN_DISCLAIMER,
  SET_LIST_STOCK,
  RESET_LIST_STOCK,
  SET_LIVE_TRADE_DETAIL,
  SET_STATUS_QA,
  REMOVE_LIST_TIKET,
  SET_LIST_ANALYST,
  SET_ANALYST,
  CLEAR_LIST_ANALYST,
  SET_LIST_BANNER_EDUCATION,
  SET_EDUCATION_HOME,
  SET_ANALYST_HOME,
  SET_FAQ_HOME,
  SET_LAST_PRICE,
  SET_FILTER,
  CLEAR_FILTER,
  SET_SEARCH,
  OPEN_SEARCH,
  SET_Y_POS,
  SET_AUTO_ANSWER,
  SET_ENABLE_FEATURE,
  SET_SUBSCRIPTION,
  SET_MEMBERSHIP_STATUS,
  SET_MEMBER_DETAILS,
  SET_LIST_QUESTION,
  SET_CHART_STOCK,
  CLEAR_LIST_QUESTION,
  SET_PROMOTION_POPUP,
  SET_PROMOTION_DETAIL,
  SET_FOR_YOU,
  SET_LANDINGPAGE,
  SET_INPUT_RECORD,
  RESET_INPUT_RECORD,
  SET_VERIFY_USER_ACCOUNT,
  SET_MAX_QNA_ACTIVE,
  SET_PORTFOLIO_QA,
  SET_HAS_ONGOING_QNA,
  SET_QNA_RECORD,
  RESET_ERROR,
  SET_FORGOT_SUCCESS_DIALOG,
  SET_OTP_RECORD,
  SET_RESEND_OTP_REMAINING,
  SET_IS_CLOSE_POPUP_BANNER,
  SET_APPEARED_PROMOTIONS,
  SET_IS_PREMIUM_CONTENT,
  SET_IS_VIP_FEATURES,
  SET_PREVIEW_IMAGE,
  SET_CHART_CONFIG,
  SET_PAGE_HISTORY,
  SET_SPINNER_LOADING,
  SET_DIAL_CODE,
  SET_IS_TO_MANY_LOGIN,
  SET_IS_OPEN_MODAL_REWARD_RISK_RATIO_CALCULATION,
  SET_IS_OPEN_MODAL_CONTACT_SUPPORT,
  SET_IS_OPEN_MODAL_VIDEO_TUTORIAL,
  SET_IS_OPEN_MODAL_SHARE,
  SET_IS_OPEN_MODAL_SUCCESS_CHANGE_PASSWORD,
}
